export const enviroment = {
  baseApi: "https://beemove-webapp.azurewebsites.net",
  // baseApi: "http://localhost:5032",
  // baseApi: "https://beemove-webapp-development.azurewebsites.net",
  baseUrl: "http://localhost:3000/",
  MapsKey: "AIzaSyCaCcyoHcSIwb5DSBtku4XdwrXQZ-elwBQ",
  // baseUrl: "http://localhost:3000/",
};
// Credenciais de solicitar a Coleta
// beemove-std-api
// 4&Q7S!6lc@

// 400 com o final B1 = 404 pedido não existe